
import { defineComponent } from "vue";

const __default__ = defineComponent({
  props: {
    height: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "initial"
    },
    minHeight: {
      type: String,
      default: "initial"
    },
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    zIndex: {
      type: String,
      default: "initial"
    },
    id: {
      type: String,
      required: false
    }
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "6b1b5f14": (_ctx.maxHeight),
  "cdb314fc": (_ctx.minHeight),
  "91f44904": (_ctx.backgroundColor),
  "9a6a04a2": (_ctx.zIndex)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__